// Display name and web domain per banner key.
// Display names mirror src/common/env/env-uca.js bannerConfiguration where defined,
// with fallbacks for banners not configured there (andronicos, balduccis, haggen, kingsfoodmarkets).
const BANNER_INFO = {
  albertsons: { displayName: "Albertsons", domain: "albertsons.com" },
  tomthumb: { displayName: "Tom Thumb", domain: "tomthumb.com" },
  vons: { displayName: "Vons", domain: "vons.com" },
  safeway: { displayName: "Safeway", domain: "safeway.com" },
  randalls: { displayName: "Randalls", domain: "randalls.com" },
  pavilions: { displayName: "Pavilions", domain: "pavilions.com" },
  jewelosco: { displayName: "Jewel-Osco", domain: "jewelosco.com" },
  carrsqc: { displayName: "Carrs", domain: "carrsqc.com" },
  acmemarkets: { displayName: "Acme Markets", domain: "acmemarkets.com" },
  shaws: { displayName: "Shaws", domain: "shaws.com" },
  starmarket: { displayName: "Star Market", domain: "starmarket.com" },
  andronicos: { displayName: "Andronico's", domain: "andronicos.com" },
  balduccis: { displayName: "Balducci's", domain: "balduccis.com" },
  haggen: { displayName: "Haggen", domain: "haggen.com" },
  kingsfoodmarkets: { displayName: "Kings Food Markets", domain: "kingsfoodmarkets.com" },
  shopamigos: { displayName: "Amigos", domain: "shop.amigosunited.com" },
  shopunitedsupermarkets: { displayName: "United Supermarkets", domain: "shop.unitedsupermarkets.com" },
  shopmarketstreet: { displayName: "Market Street", domain: "shop.marketstreetunited.com" },
  shopalbertsonsmarket: { displayName: "Albertsons Market", domain: "shop.albertsonsmarket.com" },
};

const capitalize = (s) =>
  s && typeof s === "string" ? s.charAt(0).toUpperCase() + s.slice(1) : s;

export const getBannerDisplayName = (bannerKey) =>
  (BANNER_INFO[bannerKey] && BANNER_INFO[bannerKey].displayName) || capitalize(bannerKey);

export const getBannerDomain = (bannerKey) =>
  (BANNER_INFO[bannerKey] && BANNER_INFO[bannerKey].domain) ||
  `${(bannerKey || "").toLowerCase()}.com`;

export const substituteBanner = (text, bannerKey) => {
  if (!text) return text;
  const displayName = getBannerDisplayName(bannerKey);
  const domain = getBannerDomain(bannerKey);
  return text
    .replaceAll("[bannerDomain]", domain)
    .replaceAll("[banner]", displayName);
};
